import { defineStore } from "pinia";
import * as _debug from "debug";
import ApiClient from "@/lib/ApiClient";
import { createStore } from "./storeHelper";

const debug = _debug(`${process.env.VUE_APP_PREFIX}:AccountStore`);

export const useAccountStore = defineStore(
  "account",
  createStore({
    state: {
      info: {},
    },

    getters: {
      checklistsFeatureEnabled: (state) => {
        return state.info.enabledFeatures?.some(
          (x) => x.technicalIdentifier === "checklists",
        );
      },
      announcementsFeatureEnabled: (state) => {
        return state.info.enabledFeatures?.some(
          (x) => x.technicalIdentifier === "announcements",
        );
      },
    },

    actions: {
      async load() {
        debug("load");
        const accountInfo = await ApiClient.get(`/account`);
        debug("load", accountInfo);
        this.set("info", accountInfo);
      },
    },
  }),
);
